export type AvailableCssVars =
    | '--aside-menu-width'
    | '--aside-menu-left'
    | '--header-menu-height'
    | '--header-height'
    | '--header-menu-item-margin-top'
    | '--layout-padding-left'
    | '--layout-padding-top'
    | '--navbar-logged-loaded';

export function setCssVariable(name: AvailableCssVars, value: string) {
    document.documentElement.style.setProperty(name, value);
}
